// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Switch_switch__Cx63Q {
  display: flex;
  align-items: center;
}
.Switch_switch__Cx63Q input[type=checkbox] {
  height: 0;
  width: 0;
  visibility: hidden;
}
.Switch_switch__Cx63Q .Switch_switch-labels__eZMUd {
  position: relative;
  z-index: 1;
  display: block;
  width: 154px;
  height: 32px;
  border: 1px solid #d8d8ff;
  border-radius: 6px;
  cursor: pointer;
  background-color: #fff;
}
.Switch_switch__Cx63Q .Switch_switch-labels__eZMUd .Switch_switch-label1__Ny3wo,
.Switch_switch__Cx63Q .Switch_switch-labels__eZMUd .Switch_switch-label2__kbpHO {
  position: absolute;
  width: 50%;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
}
.Switch_switch__Cx63Q .Switch_switch-labels__eZMUd .Switch_switch-label1__Ny3wo {
  color: #fff;
}
.Switch_switch__Cx63Q .Switch_switch-labels__eZMUd .Switch_switch-label2__kbpHO {
  right: 0;
  color: #00007a;
}
.Switch_switch__Cx63Q .Switch_switch-labels__eZMUd:after {
  content: "";
  position: absolute;
  z-index: -1;
  left: 1px;
  top: 1px;
  width: 50%;
  height: calc(100% - 2px);
  background: #4343ff;
  border-radius: 4px;
  transition: 0.3s;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  opacity: 0.5;
}
.Switch_switch__Cx63Q input:checked + .Switch_switch-labels__eZMUd .Switch_switch-label1__Ny3wo {
  color: #00007a;
}
.Switch_switch__Cx63Q input:checked + .Switch_switch-labels__eZMUd .Switch_switch-label2__kbpHO {
  color: #fff;
}
.Switch_switch__Cx63Q input:checked + .Switch_switch-labels__eZMUd:after {
  left: calc(100% - 2px);
  transform: translateX(-100%);
}
.Switch_switch__Cx63Q.Switch_colabel__xPB\\+Y .Switch_switch-labels__eZMUd {
  border-color: #C3C3C9;
}
.Switch_switch__Cx63Q.Switch_colabel__xPB\\+Y .Switch_switch-labels__eZMUd .Switch_switch-label2__kbpHO {
  color: #121217;
}
.Switch_switch__Cx63Q.Switch_colabel__xPB\\+Y .Switch_switch-labels__eZMUd:after {
  background: #121217;
}`, "",{"version":3,"sources":["webpack://./src/components/common/Switch/Switch.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;AAKF;AAHE;EACE,SAAA;EACA,QAAA;EACA,kBAAA;AAKJ;AAFE;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;AAIJ;AAFI;;EAEE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,kBAAA;AAIN;AADI;EACE,WAAA;AAGN;AAAI;EACE,QAAA;EACA,cC/BK;ADiCX;AAEE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,wBAAA;EACA,mBC/CO;EDgDP,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AAAJ;AAII;EACE,cCtDK;ADoDX;AAKI;EACE,WAAA;AAHN;AAOE;EACE,sBAAA;EACA,4BAAA;AALJ;AASI;EACE,qBCxCc;ADiCpB;AASM;EACE,cC1Ca;ADmCrB;AAUI;EACE,mBC9Ce;ADsCrB","sourcesContent":["@use 'styles/colors.scss';\n\n.switch {\n  display: flex;\n  align-items: center;\n\n  input[type='checkbox'] {\n    height: 0;\n    width: 0;\n    visibility: hidden;\n  }\n\n  .switch-labels {\n    position: relative;\n    z-index: 1;\n    display: block;\n    width: 154px;\n    height: 32px;\n    border: 1px solid colors.$primary2;\n    border-radius: 6px;\n    cursor: pointer;\n    background-color: #fff;\n\n    .switch-label1,\n    .switch-label2 {\n      position: absolute;\n      width: 50%;\n      top: 50%;\n      transform: translateY(-50%);\n      text-align: center;\n    }\n\n    .switch-label1 {\n      color: #fff;\n    }\n\n    .switch-label2 {\n      right: 0;\n      color: colors.$primary8;\n    }\n  }\n\n  .switch-labels:after {\n    content: '';\n    position: absolute;\n    z-index: -1;\n    left: 1px;\n    top: 1px;\n    width: 50%;\n    height: calc(100% - 2px);\n    background: colors.$primary4;\n    border-radius: 4px;\n    transition: 0.3s;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 28px;\n    opacity:0.5;\n  }\n\n  input:checked + .switch-labels {\n    .switch-label1 {\n      color: colors.$primary8;\n    }\n\n    .switch-label2 {\n      color: #fff;\n    }\n  }\n\n  input:checked + .switch-labels:after {\n    left: calc(100% - 2px);\n    transform: translateX(-100%);\n  }\n\n  &.colabel{\n    .switch-labels{\n      border-color: colors.$colabelNeutralMid;\n\n      .switch-label2{\n        color: colors.$colabelNeutralDark;\n      }\n    }\n    .switch-labels:after{\n      background: colors.$colabelNeutralDark;\n    }\n  }\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"switch": `Switch_switch__Cx63Q`,
	"switch-labels": `Switch_switch-labels__eZMUd`,
	"switch-label1": `Switch_switch-label1__Ny3wo`,
	"switch-label2": `Switch_switch-label2__kbpHO`,
	"colabel": `Switch_colabel__xPB+Y`
};
export default ___CSS_LOADER_EXPORT___;
